module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "author-pane"
  }, [_c('div', {
    staticClass: "author-mask",
    style: (_vm.authorStyle)
  }, [_c('div', {
    staticClass: "image-border-mask"
  }, [(_vm.authorImage) ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.authorImage),
      expression: "authorImage"
    }],
    staticClass: "author-image image grayscale"
  }) : _c('svg-default-avater', {
    staticClass: "author-image image",
    attrs: {
      "width": "100%",
      "height": "100%"
    }
  })], 1)]), _c('div', {
    staticClass: "author-info"
  }, [(_vm.author.title) ? _c('div', {
    staticClass: "author-list"
  }, [(_vm.authors) ? _c('div', {
    staticClass: "authors"
  }, _vm._l((_vm.authors), function(author, key) {
    return _c('div', {
      staticClass: "author-name"
    }, [_c('term-link', {
      attrs: {
        "tid": author.tid,
        "title": author.title,
        "url": author.relative_url,
        "type": author.type
      }
    }, [_vm._v("\n            " + _vm._s(author.title) + "\n          ")]), _c('br')], 1)
  })) : _vm._e()]) : _vm._e(), _c('field-date', {
    attrs: {
      "node": _vm.node
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73285423","hasScoped":true,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/node/AuthorPane.vue
// module id = 1178
// module chunks = 23 25